import { useEffect, useMemo, useRef } from 'react';

import type { IBreadcrumbItem } from '@/DesignSystem/Model/DataModel';
import { selectedGradeSelector } from '@/Module/Grade/Store/Selector/findGradeSelector';
import { prepareGradeBreadCrumb } from '@/Module/Lesson/Helper';
import { getLessonListByCourseIdAction } from '@/Module/Lesson/Store/Action';
import { selectedCourseSelector } from '@/Module/Lesson/Store/Selector/selectedCourseSelector';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';

export const useLessonSectionPage = () => {
  const dispatch = useAppDispatch();
  const isInitialed = useRef(false);

  const course = useAppSelector(selectedCourseSelector)!;
  const grade = useAppSelector(selectedGradeSelector)!;
  const page = useAppSelector(state => state.lessonSection.page);

  const breadcrumb: IBreadcrumbItem[] = useMemo(() => prepareGradeBreadCrumb(course, grade), [grade, course]);

  useEffect(() => {
    if (!course?.id || !isInitialed.current) {
      isInitialed.current = true;
      return () => {};
    }

    const promise = dispatch(
      getLessonListByCourseIdAction({
        courseId: course.id,
      }),
    );

    return () => {
      promise.abort();
    };
  }, [page, course?.id]);

  return {
    breadcrumb,
  };
};
